import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, Directive, HostListener, ViewEncapsulation } from '@angular/core';
import { Location, DatePipe } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup, ValidatorFn, AbstractControl, UntypedFormControl } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { PrintService } from '../../services/print.service'
import { CustomerService } from '../../services/customer.service'
import { TaxesService } from '../../services/taxes.service'
import { GeneralLedgerService } from '../../services/general-ledger.service'
import { InventoryService } from '../../services/inventory.service'
import { trigger, state, style, transition, animate } from '@angular/animations';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ThisReceiver } from '@angular/compiler';
import { Console } from 'console';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
	selector: 'app-reward-points',
	templateUrl: './reward-points.component.html',
	styleUrls: ['./reward-points.component.scss'],
	animations: [
		trigger('slide', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: 0, width: 0, overflow: 'hidden' }),
				animate(100, style({ height: '*', width: '*', transform: 'translateX(2000px)', overflow: 'hidden' })),
				animate('100ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(150, style({ height: 0, width: 0, overflow: 'hidden' })),
				animate('150ms', style({ height: '0', width: '0', opacity: 0, transform: 'translateX(2000px)' }))
			])
		]),
	]
})
export class RewardPointsComponent implements OnInit{
	@ViewChild('addModal') addRef: ElementRef;
	@ViewChild('transModal') transRef: ElementRef;
	@ViewChild('addRewardModal') rewardRef: ElementRef;
	@ViewChild('print_table') exportRef: ElementRef;
	private sort: MatSort;

	@ViewChild(MatSort) set matSort(ms: MatSort) {
		this.sort = ms;
		this.setDataSourceAttributes();
	}

	
	setDataSourceAttributes() {
		this.dataSource.paginator = this.paginator;
	}
	
	setDataSourceAttributes2() {
		this.dataSource2.paginator = this.paginator2;
	}

	color = 'blue';
	
	items_per_page = [25, 50, 100, 500];
	pagesizedefault = 25;
	config: any;
	selectedcust: any = false;
	searchingcustomers: any = [];
	allcustomers: any = [];
	rewardForm: UntypedFormGroup;
	customersearch = new UntypedFormControl('');
	rewardsearch = new UntypedFormControl('');
	activecust = new UntypedFormControl('1');
	dataSource: MatTableDataSource < any > ;
	dataSource2: MatTableDataSource < any > ;
	rewardstockdesc: any = '';
	filteredProds: Observable<string[]>;
	prods: string[] = [];
	allProds: string[] = [];
	rewardList: any = [];
	filteredRewards: any = [];
	@ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
	@ViewChild(MatPaginator, { static: false }) paginator2: MatPaginator;
	
	pointvalue = new UntypedFormControl('');
	comment = new UntypedFormControl('');
	dataObs: Observable < any > ;
	dataObs2: Observable < any > ;
	
	constructor(private printService: PrintService, private _changeDetectorRef: ChangeDetectorRef, private inventoryService: InventoryService, private fb: UntypedFormBuilder, private customerService: CustomerService, private globalSearchService: GlobalSearchService, public cdr: ChangeDetectorRef, private modalService: NgbModal) {
		this.color = this.globalSearchService.getColor();
		
		const data = { activeonly: this.activecust.value };
		this.customerService.getRewardsTotals(data).subscribe(async results => {
			this.allcustomers = results;
			this.searchingcustomers = results;
			this.setPagination(this.searchingcustomers);
		});
		
		this.customerService.getRewardsList().subscribe(async results => {
			this.rewardList = results;
			this.filteredRewards = results;
			this.setPagination2(this.filteredRewards);
		});
	}
	
	ngOnInit(){
	
		this.rewardForm = this.fb.group({
			rewardcode: ['', Validators.required],
			pointcost: ['', Validators.required],
			active: [false],
			startdate: [''],
			enddate: [''],
			loccode: [''],
			rewardtype: ['P'],
			discount: [0],
			stockid: [''],
		});
		this.filteredProds = this.rewardForm.get('stockid').valueChanges.pipe(
			startWith(''),
			debounceTime(400),
			distinctUntilChanged(),
			switchMap(val => {
				if (val != '') {
					return this.filter(val || '')
				} else {
					return [];
				}
			})
		)
	}
	back(){
	
	}
	adjust(cust: any){
		this.selectedcust = cust;
		this.pointvalue.setValue(0);
		this.comment.setValue('');
		this.modalService.open(this.addRef, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {

		}, (reason) => {

		});
	
	}
	showTrans(cust: any){
		const data = { debtorno: cust.debtorno, branchcode: cust.branchcode };
		this.customerService.getRewardsTrans(data).subscribe(async results => {
			this.selectedcust = results;
			this.modalService.open(this.transRef, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {

			}, (reason) => {

			});
		});
	}
	filterRewards(){
		const search = this.rewardsearch.value.toLowerCase();
		if (search) {
			this.filteredRewards = this.rewardList.filter(p => {
				 return p.rewardtype.toLowerCase().includes(search) || p.rewardstockid.toLowerCase().includes(search);
			}
			);
		} else {
			this.filteredRewards = this.rewardList;
		}
		this.setPagination2(this.filteredRewards);
	
	}
	clearRSearch(){
	
		this.rewardsearch.setValue('');
		this.filterRewards();
	}
	filterCust(){
		const search = this.customersearch.value.toLowerCase();
		if (search) {
			this.searchingcustomers = this.allcustomers.filter(p => {
				 return p.debtorno.toLowerCase().includes(search) || p.brname.toLowerCase().includes(search);
			}
			);
		} else {
			this.searchingcustomers = this.allcustomers;
		}
		this.setPagination(this.searchingcustomers);
	}
	clearCSearch(){
		this.customersearch.setValue('');
		this.filterCust();
	}
	getCustomers(){
	
		const data = { activeonly: this.activecust.value };
		this.customerService.getRewardsTotals(data).subscribe(async results => {
			this.allcustomers = results;
			this.searchingcustomers = results;
			this.setPagination(this.searchingcustomers);
		});
	}
	postAdjustment(){
	
		const submit = { debtorno: this.selectedcust.debtorno, branchcode: this.selectedcust.branchcode, amount: this.pointvalue.value, comments: this.comment.value };
		this.customerService.addRewardsTrans(submit).subscribe(async results => {
			const data = { activeonly: true };
			this.customerService.getRewardsTotals(data).subscribe(async results => {
				this.allcustomers = results;
				this.searchingcustomers = results;
				this.setPagination(this.searchingcustomers);
				this.modalService.dismissAll();
			});
		
		});
	}
	
	setPagination(tableData) {
		this.dataSource = new MatTableDataSource < any > (tableData);
		this._changeDetectorRef.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}
	setPagination2(tableData) {
		this.dataSource2 = new MatTableDataSource < any > (tableData);
		this._changeDetectorRef.detectChanges();
		this.dataSource2.paginator = this.paginator2;
		this.dataObs2 = this.dataSource2.connect();
	}
	selected(event: MatAutocompleteSelectedEvent): void {
		const input = (event.option.viewValue).toString().split(':');
		const stockid = input[0].trim();
		const description = input[1].trim();

		this.rewardForm.get('stockid').setValue(stockid);
		this.rewardstockdesc = description;
	}
	filter(val: string): Observable<any> {
		return this.inventoryService.itemSearch({ search: val, type: ['igr'], discontinued: false })
			.pipe(
				map(response => response.filter(option => {
					return (
						(option.stockid.toLowerCase().indexOf(val.toLowerCase()) === 0 || option.description.toLowerCase().includes(val.toLowerCase())) && !this.prods.includes(option.stockid)
					)
				}))
			)
	}
	addReward(){
	
		this.modalService.open(this.rewardRef, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {

		}, (reason) => {

		});
	}
	
	saveReward(){
	
		this.customerService.saveReward(this.rewardForm.value).subscribe(async results => {
			this.rewardList = results;
			this.setPagination2(this.rewardList);
			this.modalService.dismissAll();
		});
	
	}
	editReward(p: any){
		this.rewardForm = this.fb.group({
			rewardcode: [p.rewardtype, Validators.required],
			pointcost: [p.pointvalue, Validators.required],
			active: [p.active],
			startdate: [p.datefrom],
			enddate: [p.dateto],
			loccode: [p.loccode],
			rewardtype: [p.discountType],
			discount: [p.currencyvalue],
			stockid: [p.rewardstockid],
		});
		
		this.modalService.open(this.rewardRef, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {

		}, (reason) => {

		});
	}
	
	removeReward(p: any){
		if(confirm('Really delete reward with code '+p.rewardtype+' ?')){
		
			
			this.customerService.saveReward(p).subscribe(async results => {
				this.rewardList = results;
				this.setPagination2(this.rewardList);
			});
		}
	}
	
	exportPDF(ref: any) {
		const now = new Date();
		const filename = 'Reward Transactions';
		const encoded: string = this.globalSearchService.base64encode(ref.innerHTML);
		const data = {
			content: encoded,
			filename: filename,
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	exportXls(ref: any) {
		const filename = 'Reward Transactions';
		const encoded: string = this.globalSearchService.base64encode(ref.innerHTML);
		const data = {
			content: encoded,
			filename: filename,
			title: this.selectedcust.debtorno + 'Reward Transactions',
			subtitle: ''
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}
	
	
}
